import { Box } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import ReactDatePicker from 'react-datepicker';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';

interface Props {
  selectedStartDate: Date;
  selectedEndDate: Date;
  onDateChange: (dates: [Date, Date]) => void;
}

const CustomDatePicker = (props: Props) => {
  const { theme } = useAppSelector((state) => state.authReducer.customer);
  const darkMode = isDarkTheme(theme);
  const { selectedStartDate, selectedEndDate, onDateChange } = props;
  return (
    <Box
      className="flex flex-col z-50 relative"
      sx={{
        backgroundColor: 'transparent',
        // padding: '8px 12px',
        borderRadius: '8px',
        // boxShadow: darkMode
        //   ? '0 2px 6px rgba(0,0,0,0.2)'
        //   : '0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      <Box
        component="p"
        className="text-xs dark:text-white text-black absolute top-[-12px] left-3 z-50 bg-transparent"
        sx={{
          fontWeight: 400,
          fontSize: '0.75rem',
          color: darkMode ? ThemePalette.typography.white : '#000',
          lineHeight: '23px',
        }}
      >
        Select Date Range
      </Box>
      <Box
        sx={{
          width: '110px',
          height: '6px',
          position: 'absolute',
          top: '-1px',
          left: '10px',
          backgroundColor: darkMode ? '#162a46' : 'white',
          zIndex: 49,
        }}
      />
      <ReactDatePicker
        showIcon
        selected={selectedStartDate}
        onChange={(dates) => {
          if (Array.isArray(dates)) {
            onDateChange(dates as [Date, Date]);
          }
        }}
        startDate={selectedStartDate}
        endDate={selectedEndDate}
        selectsRange
        maxDate={new Date()}
        className={
          darkMode
            ? 'custom-datepicker-prod'
            : 'custom-datepicker-prod-light-theme'
        }
      />
    </Box>
  );
};

export default CustomDatePicker;
